<div class="container personas">
    <h1 class="titulo-terminos" *ngIf="languaje === 'en'">IMAGINE ALL AS ONE TERMS AND CONDITIONS</h1>
    <h1 class="titulo-terminos" *ngIf="languaje === 'es'">IMAGINE ALL AS ONE TÉRMINOS Y CONDICIONES</h1>
    <div class="contenedor-pestanas" [style.margin]="param ? '0' : '20px 0'">
      <div class="row tab-v3">
        <div class="col-12 col-lg-3 pestanas">
          <ul class="nav nav-pills nav-stacked">
            <app-glossary-miles-blue (x)="resetFlags(); tabs_state.glosary = true" [is_active]="tabs_state.glosary"
            style="width: 100%"></app-glossary-miles-blue>
            <app-program-definition-imagine (x)="resetFlags(); tabs_state.miles_upperclub_program = true"
            [is_active]="tabs_state.miles_upperclub_program" style="width: 100%"></app-program-definition-imagine>
            <app-general-conditions-miles-blue (x)="resetFlags(); tabs_state.miles_upper_general = true" [is_active]="tabs_state.miles_upper_general"
            style="width: 100%"></app-general-conditions-miles-blue>
            <app-flexway-imagine (x)="resetFlags(); tabs_state.flex = true" [is_active]="tabs_state.flex" style="width: 100%"></app-flexway-imagine>
            <app-stay-care (x)="resetFlags(); tabs_state.stay_care = true" [is_active]="tabs_state.stay_care"
            style="width: 100%"></app-stay-care>
            <app-fly-care-imagine (x)="resetFlags(); tabs_state.fly_care = true" [is_active]="tabs_state.fly_care"
            style="width: 100%"></app-fly-care-imagine>
            <app-other-benefits-miles-blue (x)="resetFlags(); tabs_state.other = true" [is_active]="tabs_state.other"
            style="width: 100%"></app-other-benefits-miles-blue>          
            <app-exclusions (x)="resetFlags(); tabs_state.exclusion = true" [is_active]="tabs_state.exclusion"
              style="width: 100%"></app-exclusions>
            <app-coverage-information-miles-blue (x)="resetFlags(); tabs_state.coverage_information = true" [is_active]="tabs_state.coverage_information"
              style="width: 100%"></app-coverage-information-miles-blue>
            <app-website-imagine (x)="resetFlags(); tabs_state.website = true" [is_active]="tabs_state.website" style="width: 100%">
            </app-website-imagine>
            <app-coverage-dispositions-imagine (x)="resetFlags(); tabs_state.coverage_dispositions = true" [is_active]="tabs_state.coverage_dispositions"
              style="width: 100%"></app-coverage-dispositions-imagine>
  
            
            <app-service-imagine (x)="resetFlags(); tabs_state.service = true" [is_active]="tabs_state.service"
              style="width: 100%"></app-service-imagine>
            <app-privacy (x)="resetFlags(); tabs_state.privacy = true" [is_active]="tabs_state.privacy"
              style="width: 100%"></app-privacy>
          </ul>
        </div>
        <div class="col-12 col-lg-9 contenido">
          <div class="tab-content">
            <app-glossary-miles-blue [show_content]="tabs_state.glosary"></app-glossary-miles-blue>
            <app-program-definition-imagine [show_content]="tabs_state.miles_upperclub_program"></app-program-definition-imagine>
            <app-general-conditions-miles-blue [show_content]="tabs_state.miles_upper_general"></app-general-conditions-miles-blue>
            <app-flexway-imagine [show_content]="tabs_state.flex"></app-flexway-imagine>
            <app-stay-care [show_content]="tabs_state.stay_care"></app-stay-care>
            <app-fly-care-imagine [show_content]="tabs_state.fly_care"></app-fly-care-imagine>
            <app-other-benefits-miles-blue [show_content]="tabs_state.other"></app-other-benefits-miles-blue>
            <app-exclusions [show_content]="tabs_state.exclusion"></app-exclusions>
            <app-coverage-information-miles-blue [show_content]="tabs_state.coverage_information"></app-coverage-information-miles-blue>
            <app-website-imagine [show_content]="tabs_state.website"></app-website-imagine>
            <app-coverage-dispositions-imagine [show_content]="tabs_state.coverage_dispositions"></app-coverage-dispositions-imagine>
            
            <app-service-imagine [show_content]="tabs_state.service"></app-service-imagine> 
            <app-privacy [show_content]="tabs_state.privacy"></app-privacy>
          </div>
        </div>
      </div>
    </div>
</div>
  